// Firefox and Safari can drop a download whose address is revoked as its
// link is clicked, so the address lasts a minute (#864).
const KEEP_ADDRESS_MS = 60_000;

/** Save a file the API sent (a capture's zip, a report's CSV) as `filename`.
 * The link goes on the page for its click: Firefox ignores a click on a link
 * that isn't (#864). */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.hidden = true;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, KEEP_ADDRESS_MS);
}
